// impedimentosStore.js — avisos de impedimento que los PROFESORES mandan desde su página «Tu semana» en el
// simulador (9/10/2026). En la app real es una petición `kind: "impedimento_profesor"` en c_peticiones_practica que
// llega a Planificación → Peticiones; aquí vive en memoria para que el aviso mandado desde cualquier vista previa
// (Planificación o Mensajes automáticos) aparezca en las Peticiones del panel de Planificación.
import { useSyncExternalStore } from "react";

let _lista = [];
const _subs = new Set();
const emit = () => _subs.forEach((fn) => { try { fn(); } catch { /* noop */ } });

export function subscribeImpedimentos(fn) {
  _subs.add(fn);
  return () => _subs.delete(fn);
}
export const getImpedimentos = () => _lista;
export function useImpedimentos() {
  return useSyncExternalStore(subscribeImpedimentos, getImpedimentos, getImpedimentos);
}

/**
 * @param {{ instructor_id, profesor_nombre, fecha, todo_el_dia, desde, hasta, motivo, practica_ids }} imp
 * Idempotente como el real: el mismo aviso (profesor, día, franja y motivo) no se apunta dos veces.
 */
export function addImpedimento(imp) {
  const id = `pi_${[imp.instructor_id, imp.fecha, imp.desde || "", imp.hasta || "", imp.motivo].join("|")}`;
  if (_lista.some((x) => x.peticion_id === id)) return _lista.find((x) => x.peticion_id === id);
  const item = { ...imp, peticion_id: id, kind: "impedimento_profesor", status: "pendiente", created_at: new Date().toISOString() };
  _lista = [item, ..._lista];
  emit();
  return item;
}

/** «Marcar como resuelta» (la quita de las pendientes). */
export function resolverImpedimento(peticionId) {
  const antes = _lista.length;
  _lista = _lista.filter((x) => x.peticion_id !== peticionId);
  if (_lista.length !== antes) emit();
}

export function resetImpedimentos() {
  _lista = [];
  emit();
}
